// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import resource from 'vue-resource'
import store from './store'
import Axios from 'axios'
import "./assets/css/animation.css";
import "./assets/css/index.css";
import "./assets/css/memodal-default-theme.css";
import "./assets/css/menu.css";
import "./assets/css/remodal.css";
import "./assets/css/nice-select.css";
// import "./assets/css/reponsive.css";
import "./assets/css/slick.css";
Vue.config.productionTip = false;
Vue.use(resource)
    // Vue.prototype.$Axios = Axios
    // Vue.prototype.$apiUrl = 'http://222.70.151.78:4002'



/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js